// extracted by mini-css-extract-plugin
export var circle = "_g8-1";
export var exitConfirmationModal = "_g8-5";
export var iframe = "_g8-0";
export var offline = "_g8-3";
export var online = "_g8-2";
export var workstationSelectError = "_g8-4";